var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-select",
    _vm._g(
      _vm._b(
        {
          attrs: {
            multiple: "",
            options: _vm.transformed_options,
            reduce: function reduce(option) {
              return option.id
            },
          },
          model: {
            value: _vm.selected,
            callback: function callback($$v) {
              _vm.selected = $$v
            },
            expression: "selected",
          },
        },
        "v-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "div",
        {
          attrs: {
            slot: "no-options",
          },
          slot: "no-options",
        },
        [_c("translate", [_vm._v("Keine Auswahlmöglichkeiten")])],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }